import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PopupMessage from "../components/PopupMessage";
import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import PermissionsIcon from "@material-ui/icons/SettingsApplicationsOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },
  redCell: {
    color: "red",
  },
  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },
  spacer: {
    flex: "1 1 100%",
  },

  table: {
    border: "1px solid black",
    margin: "20px",
    width: 700,
  },
});

class ViewUserDetailsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      viewPopup: false,
      permissionsLoaded: false,
      perms: [],
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ errorString: "" });
  }

  showPermissions(e) {
    fetch("on_user_permissions", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: this.props.item.id,
        active: false,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ perms: reply.perms });
          this.setState({ permissionsLoaded: true });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  render() {
    const { classes } = this.props;
    let items = this.state.perms;
    let { t } = this.props;
    return (
      <div>
        <div className={classes.tableWrapper}>
          {this.state.viewPopup && this.state.errorString.length > 0 && (
            <PopupMessage
              title="Error"
              text={this.state.errorString}
              error={true}
              onClosePopup={this.onClosePopup}
            />
          )}

          <div>
            <table style={{ marginLeft: 30, marginTop: 30, marginBottom: 10 }}>
              <Paper elevation={6}>
                <tr>
                  <td width="200">
                    <Typography variant="subheading" color="primary">
                      {" "}
                      {t("userName.label")}:
                    </Typography>
                  </td>
                  <td width="450"> {this.props.item.contact}</td>
                  <td width="200">
                    {" "}
                    <Typography variant="subheading" color="primary">
                      &nbsp;&nbsp;{t("ssoUserName.label")}:{" "}
                    </Typography>
                  </td>
                  <td width="450"> {this.props.item.ssoName}</td>
                </tr>
                <tr style={{ height: 10 }} />
                <tr>
                  <td>
                    {" "}
                    <Typography variant="subheading" color="primary">
                      {t("email.label")}:{" "}
                    </Typography>
                  </td>
                  <td> {this.props.item.email}</td>
                  <td>
                    {" "}
                    <Typography variant="subheading" color="primary">
                      &nbsp;&nbsp;{t("lan.label")}:&nbsp;&nbsp;{" "}
                    </Typography>
                  </td>
                  <td> {this.props.item.language}</td>
                </tr>
                <tr style={{ height: 10 }} />
                <tr>
                  <td>
                    {" "}
                    <Typography variant="subheading" color="primary">
                      {t("phoneNumber.label")}:{" "}
                    </Typography>
                  </td>
                  <td> {this.props.item.phone}</td>
                  <td>
                    {" "}
                    <Typography variant="subheading" color="primary">
                      &nbsp;&nbsp;{t("faxNumber.label")}:{" "}
                    </Typography>
                  </td>
                  <td> {this.props.item.fax}</td>
                </tr>
                <tr style={{ height: 10 }} />
                <tr>
                  <td>
                    {" "}
                    <Typography variant="subheading" color="primary">
                      {t("street.label")}:
                    </Typography>
                  </td>
                  <td> {this.props.item.street}</td>
                  <td>
                    {" "}
                    <Typography variant="subheading" color="primary">
                      &nbsp;&nbsp;{t("city.label")}:
                    </Typography>
                  </td>
                  <td> {this.props.item.city}</td>
                </tr>
                <tr style={{ height: 10 }} />
                <tr>
                  <td>
                    {" "}
                    <Typography variant="subheading" color="primary">
                      {t("state.label")}:
                    </Typography>
                  </td>
                  <td> {this.props.item.state}</td>
                  <td>
                    {" "}
                    <Typography variant="subheading" color="primary">
                      &nbsp;&nbsp;{t("zip.label")}:
                    </Typography>
                  </td>
                  <td> {this.props.item.zip}</td>
                </tr>
                <tr style={{ height: 10 }} />
                {!this.props.uiExclusionsList.includes("PROFILE_SQA") && (
                  <tr>
                    <td>
                      {" "}
                      <Typography variant="subheading" color="primary">
                        {t("secretQuestion.label")}:
                      </Typography>
                    </td>
                    <td> {this.props.item.secretQuestion}</td>
                    <td>
                      {" "}
                      <Typography variant="subheading" color="primary">
                        &nbsp;&nbsp;{t("secretAnswer.label")}:
                      </Typography>
                    </td>
                    <td> {this.props.item.secretAnswer}</td>
                  </tr>
                )}
                <tr style={{ height: 10 }} />
              </Paper>
            </table>
            {!this.state.permissionsLoaded && (
              <Button
                style={{ marginLeft: 30 }}
                color="primary"
                onClick={(event) => this.showPermissions(event)}
              >
                <PermissionsIcon />
                &nbsp;
                {t("showPermit.button")}
              </Button>
            )}
            {this.state.permissionsLoaded && items.length === 0 && (
              <h3 style={{ marginLeft: 30, color: "primary" }}>
                {t("noPermit.label")}
              </h3>
            )}
            {this.state.permissionsLoaded && items.length > 0 && (
              <div>
                <Typography
                  style={{ marginLeft: 30 }}
                  variant="title"
                  color="textSecondary"
                >
                  {t("permissions.label")}
                </Typography>
                <Paper>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>{t("objName.header")}</TableCell>
                        <TableCell>{t("objId.header")}</TableCell>
                        <TableCell>{t("objType.header")}</TableCell>
                        <TableCell>{t("accessRights.header")}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {items.map((item) => {
                        return (
                          <TableRow key={item.index}>
                            <TableCell component="th" scope="row">
                              {item.objectName}
                            </TableCell>
                            <TableCell>{item.objectId}</TableCell>
                            <TableCell>
                              {"1" === item.objectType
                                ? t("dataObj.label")
                                : "2" === item.objectType
                                ? t("business.label")
                                : t("userInterface.label")}
                            </TableCell>
                            <TableCell>
                              {item.create && <span>{t("create.label")} </span>}
                              {item.delete && (
                                <span>{t("delete.button")} </span>
                              )}
                              {item.read && <span>{t("read.label")} </span>}
                              {item.write && <span>{t("write.label")} </span>}
                              {item.execute && (
                                <span>{t("execute.label")} </span>
                              )}
                              {item.show && <span>{t("show.label")} </span>}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Paper>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(ViewUserDetailsPage));
